// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-testid=toast-stack]:has([data-testid=message-notification-alert]){top:68px}", "",{"version":3,"sources":["webpack://src/admin/components/MessagesNotification/notificationAlert.scss"],"names":[],"mappings":"AAAA,wEACI,QAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
